import { Component, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '../../../../../services/auth.services'
import { RestServices } from '../../../../../services/rest.services'
import { SharedServices } from '../../../../../services/shared.services'
import { FormBuilder } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { ClientTopServices } from '../../../../../services/ClientTop.services'
import { MatrixServices } from '../../../../../services/image/matrix.services'
import { openActionSheet } from 'onsenui'

@Component({
    selector: 'app-modal-client-detail-top-comparison',
    templateUrl: './modal-client-detail-comparison.component.html',
    styleUrls: [
        './modal-client-detail-comparison.component.css',
        '../../../../../stagingcss/image-viewer.component.css',
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../stagingcss/main-body.component.css',
        '../../../../../stagingcss/lui-select.component.css',
    ],
})
export class ModalClientDetailComparisonComponent implements OnInit, OnDestroy {
    en: any = {}
    showEN: Boolean = true
    option_Comparison: String = 'hidden'
    option_Comparisontmp: String = 'active'
    TabComparisonClass: any
    TabComparisonClasstmp: String

    emitTabName: any = {}

    arrTabComparison: any[] = [
        { id: 0, name: 'Face', nameSave: 'Slideshow-Face' },
        { id: 1, name: 'Tooth', nameSave: 'Slideshow-Tooth' },
        { id: 2, name: 'Aligner', nameSave: 'Slideshow-Aligner' },
        { id: 3, name: 'X-ray', nameSave: 'Slideshow-X-ray' },
        { id: 4, name: 'Other', nameSave: 'Slideshow-Other' },
        { id: 5, name: 'Movie', nameSave: 'Slideshow-Movie' },
    ]

    arrTabComparisonTmp: any[] = []

    arrTabComparisonAligner = [
        { id: 2, name: 'Front', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 4, name: 'Upper', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 6, name: 'Lower', nameSave: 'Registration-Tooth-Lower' },
        { id: 3, name: 'Left', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 1, name: 'Right', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 5, name: 'Overjet', nameSave: 'Registration-Tooth-Overjet' },
    ]

    arrTabComparisonFace = [
        { id: 1, name: 'Front Smile', nameSave: 'Registration-Face-Front-Smile' },
        { id: 2, name: 'Front Normal', nameSave: 'Registration-Face-Front-Normal' },
        { id: 3, name: 'Side Smile', nameSave: 'Registration-Face-Side-Smile' },
        { id: 4, name: 'Side Normal', nameSave: 'Registration-Face-Side-Normal' },
        { id: 5, name: 'Other 1', nameSave: 'Registration-Face-Other-1' },
        { id: 6, name: 'Other 2', nameSave: 'Registration-Face-Other 2' },
    ]

    arrTabComparisonMovie = [
        { id: 1, name: '1', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 2, name: '2', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 3, name: '3', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 4, name: '4', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 5, name: '5', nameSave: 'Registration-Tooth-Overjet' },
        { id: 6, name: '6', nameSave: 'Registration-Tooth-Lower' },
    ]
    arrTabComparisonOther = [
        { id: 1, name: '1', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 2, name: '2', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 3, name: '3', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 4, name: '4', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 5, name: '5', nameSave: 'Registration-Tooth-Overjet' },
        { id: 6, name: '6', nameSave: 'Registration-Tooth-Lower' },
    ]
    arrTabComparisonTooth = [
        { id: 2, name: 'Front', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 4, name: 'Upper', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 6, name: 'Lower', nameSave: 'Registration-Tooth-Lower' },
        { id: 3, name: 'Left', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 1, name: 'Right', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 5, name: 'Overjet', nameSave: 'Registration-Tooth-Overjet' },

    ]
    arrTabComparisonXray = [
        { id: 1, name: '1', nameSave: 'Registration-Tooth-Front-Right' },
        { id: 2, name: '2', nameSave: 'Registration-Tooth-Front-Front' },
        { id: 3, name: '3', nameSave: 'Registration-Tooth-Side-Left' },
        { id: 4, name: '4', nameSave: 'Registration-Tooth-Side-Upper' },
        { id: 5, name: '5', nameSave: 'Registration-Tooth-Overjet' },
        { id: 6, name: '6', nameSave: 'Registration-Tooth-Lower' },
    ]

    idClient: any
    resourceUrl = 'resource'
    arrayComparison: any[] = []
    tabName: any = 'tooth-all'
    arayListNote: any[] = []
    clientInfoUrl: any
    unscrAllArrClientTop

    constructor(private _sharedService: SharedServices,
                private authData: AuthService,
                private restApi: RestServices,
                private formBuider: FormBuilder,
                private route: ActivatedRoute,
                private clientTopServices: ClientTopServices,
                public matrixServices: MatrixServices) {
    }

    ngOnInit() {
        this.option_Comparison = 'active'
        this.option_Comparisontmp = 'active'
        this.getTabRegistrationClass()
        const tabName: any = this.clientTopServices.getTabName()
        this.getTabComparisonTmp(tabName)
        this.route.parent.paramMap.subscribe(params => {
            if (params.get('id') != '') {
                this.idClient = params.get('id') ? params.get('id') : ''
                this.getRegistration()
            }
        })
        this.clientTopServices.changeEmitted$.subscribe(
            success => {
                if (success) {
                    if (success[0] === 'ModalListNoteTopComponent-ListNoteSelect') {
                        if (success[1]) {
                            this.arayListNote = success[1]
                        }
                    }
                }
            },
        )
    }

    ngOnDestroy() {
        if(this.unscrAllArrClientTop)
            this.unscrAllArrClientTop.unsubscribe()
    }

    getRegistration() {
        this.clientTopServices.changeEmittedNoteList$.subscribe(arrayNoteList => {
            if (arrayNoteList != null && arrayNoteList['arrayNoteList'] != undefined) {
                this.arayListNote = arrayNoteList['arrayNoteList']
            }
        })
        this.clientTopServices.changeEmitChangeInfoUrlChange$.subscribe(success => {
            if (success) {
                if (success[0] === 'ClientDetailComponent-clientInfoUrl') {
                    this.clientInfoUrl = success[1]
                }
            }
        })
        this.unscrAllArrClientTop = this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(arrAll => {
            // const arrAll: any = this.clientTopServices.returnArrAll();
            if (arrAll != null && arrAll['comparision'] != undefined) {
                this.arrayComparison = arrAll['comparision']
            }
        }, error1 => {
        })
    }

    getTabComparisonTmp(tabName: any){
        switch (tabName) {
            case 'face-all':
                this.arrTabComparisonTmp = this.arrTabComparisonFace
                break;
            case 'tooth-all':
                this.arrTabComparisonTmp = this.arrTabComparisonTooth
                break;
            case 'aligner-all':
                this.arrTabComparisonTmp = this.arrTabComparisonAligner
                break;
            case 'xp-all':
                this.arrTabComparisonTmp = this.arrTabComparisonXray
                break;
            case 'other-all':
                this.arrTabComparisonTmp = this.arrTabComparisonOther
                break;
            case 'movie-all':
                this.arrTabComparisonTmp = this.arrTabComparisonMovie
                break;
            default:
                this.arrTabComparisonTmp = this.arrTabComparisonTooth
                break;
        }
    }

    showLink() {
        const clientInfoUrl = this.clientInfoUrl
        const arrayClientInfoUrl = []
        for (let j = 0; j < clientInfoUrl.length; j++) {
            arrayClientInfoUrl.push(
                {
                    label: clientInfoUrl[j]['title'],
                },
            )
        }
        const labelCancel = { label: 'Cancel', icon: 'md-close' }
        arrayClientInfoUrl.push(labelCancel)
        openActionSheet({
            title: 'Open URL',
            cancelable: true,
            buttons: arrayClientInfoUrl,
            callback: i => {
                for (let k = 0; k < clientInfoUrl.length; k++) {
                    if (i === k) {
                        window.open(clientInfoUrl[k]['url'])
                    }
                }
            },
        })
    }

    getTabRegistrationClass() {
        const tabName: any = this.clientTopServices.getTabName()
        switch (tabName) {
            case 'face-1':
            case 'face-2':
            case 'face-3':
            case 'face-4':
            case 'face-5':
            case 'face-6':
                this.TabComparisonClass = 'option_0'
                this.tabName = 'face-all'
                this.emitTabName['tabName'] = 'face-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'face-all':
                this.TabComparisonClass = 'option_0'
                this.tabName = 'face-all'
                break
            case 'tooth-right':
            case 'tooth-left':
            case 'tooth-front':
            case 'tooth-upper':
            case 'tooth-overjet':
            case 'tooth-lower':
                this.TabComparisonClass = 'option_1'
                this.tabName = 'tooth-all'
                this.emitTabName['tabName'] = 'tooth-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'tooth-all':
                this.TabComparisonClass = 'option_1'
                this.tabName = 'tooth-all'
                break
            case 'aligner-right':
            case 'aligner-left':
            case 'aligner-front':
            case 'aligner-upper':
            case 'aligner-overjet':
            case 'aligner-lower':
                this.TabComparisonClass = 'option_2'
                this.tabName = 'aligner-all'
                this.emitTabName['tabName'] = 'aligner-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'aligner-all':
                this.TabComparisonClass = 'option_2'
                this.tabName = 'aligner-all'
                break
            case 'xp-1':
            case 'xp-2':
            case 'xp-3':
            case 'xp-4':
            case 'xp-5':
            case 'xp-6':
                this.TabComparisonClass = 'option_3'
                this.tabName = 'xp-all'
                this.emitTabName['tabName'] = 'xp-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'xp-all':
                this.TabComparisonClass = 'option_3'
                this.tabName = 'xp-all'
                break
            case 'other-1':
            case 'other-2':
            case 'other-3':
            case 'other-4':
            case 'other-5':
            case 'other-6':
                this.TabComparisonClass = 'option_4'
                this.tabName = 'other-all'
                this.emitTabName['tabName'] = 'other-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'other-all':
                this.TabComparisonClass = 'option_4'
                this.tabName = 'other-all'
                break
            case 'movie-1':
            case 'movie-2':
            case 'movie-3':
            case 'movie-4':
            case 'movie-5':
            case 'movie-6':
                this.TabComparisonClass = 'option_5'
                this.tabName = 'movie-all'
                this.emitTabName['tabName'] = 'movie-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
            case 'movie-all':
                this.TabComparisonClass = 'option_5'
                this.tabName = 'movie-all'
                break
            default :
                this.TabComparisonClass = 'option_1'
                this.tabName = 'tooth-all'
                this.emitTabName['tabName'] = 'tooth-all'
                this.clientTopServices.emitChangeTabName(this.emitTabName)
                break
        }
    }

    showDetailList(id, event) {
        this.TabComparisonClass = id
        this.TabComparisonClasstmp = ''
        switch (id) {
            case 'option_0':
                this.tabName = 'face-all'
                this.arrTabComparisonTmp = this.arrTabComparisonFace
                break
            case 'option_1':
                this.arrTabComparisonTmp = this.arrTabComparisonTooth
                this.tabName = 'tooth-all'
                break
            case 'option_2':
                this.arrTabComparisonTmp = this.arrTabComparisonAligner
                this.tabName = 'aligner-all'
                break
            case 'option_3':
                this.arrTabComparisonTmp = this.arrTabComparisonXray
                this.tabName = 'xp-all'
                break
            case 'option_4':
                this.arrTabComparisonTmp = this.arrTabComparisonOther
                this.tabName = 'other-all'
                break
            case 'option_5':
                this.arrTabComparisonTmp = this.arrTabComparisonMovie
                this.tabName = 'movie-all'
                break
            default:
                this.arrTabComparisonTmp = this.arrTabComparisonTooth
                this.tabName = 'tooth-all'
                break
        }

        this.emitTabName['tabName'] = this.tabName
        this.clientTopServices.emitChangeTabName(this.emitTabName)
    }

    activeDetailList(id, event) {
        this.TabComparisonClasstmp = id
        switch (this.TabComparisonClass) {
            case 'option_0':
                switch (id) {
                    case 'tmpoption_1':
                        this.tabName = 'face-1'
                        this.arrTabComparisonTmp = this.arrTabComparisonFace
                        break
                    case 'tmpoption_2':
                        this.tabName = 'face-2'
                        this.arrTabComparisonTmp = this.arrTabComparisonFace
                        break
                    case 'tmpoption_3':
                        this.tabName = 'face-3'
                        this.arrTabComparisonTmp = this.arrTabComparisonFace
                        break
                    case 'tmpoption_4':
                        this.tabName = 'face-4'
                        this.arrTabComparisonTmp = this.arrTabComparisonFace
                        break
                    case 'tmpoption_5':
                        this.tabName = 'face-5'
                        this.arrTabComparisonTmp = this.arrTabComparisonFace
                        break
                    case 'tmpoption_6':
                        this.tabName = 'face-6'
                        this.arrTabComparisonTmp = this.arrTabComparisonFace
                        break
                    default:
                        this.tabName = 'face-all'
                        this.arrTabComparisonTmp = this.arrTabComparisonFace
                        break
                }
                break
            case 'option_1':
                switch (id) {
                    case 'tmpoption_1':
                        this.tabName = 'tooth-right'
                        this.arrTabComparisonTmp = this.arrTabComparisonTooth
                        break
                    case 'tmpoption_2':
                        this.tabName = 'tooth-front'
                        this.arrTabComparisonTmp = this.arrTabComparisonTooth
                        break
                    case 'tmpoption_3':
                        this.tabName = 'tooth-left'
                        this.arrTabComparisonTmp = this.arrTabComparisonTooth
                        break
                    case 'tmpoption_4':
                        this.tabName = 'tooth-upper'
                        this.arrTabComparisonTmp = this.arrTabComparisonTooth
                        break
                    case 'tmpoption_5':
                        this.tabName = 'tooth-overjet'
                        this.arrTabComparisonTmp = this.arrTabComparisonTooth
                        break
                    case 'tmpoption_6':
                        this.tabName = 'tooth-lower'
                        this.arrTabComparisonTmp = this.arrTabComparisonTooth
                        break
                    default:
                        this.tabName = 'tooth-all'
                        this.arrTabComparisonTmp = this.arrTabComparisonTooth
                        break
                }
                break
            case 'option_2':
                switch (id) {
                    case 'tmpoption_1':
                        this.tabName = 'aligner-right'
                        this.arrTabComparisonTmp = this.arrTabComparisonAligner
                        break
                    case 'tmpoption_2':
                        this.tabName = 'aligner-front'
                        this.arrTabComparisonTmp = this.arrTabComparisonAligner
                        break
                    case 'tmpoption_3':
                        this.tabName = 'aligner-left'
                        this.arrTabComparisonTmp = this.arrTabComparisonAligner
                        break
                    case 'tmpoption_4':
                        this.tabName = 'aligner-upper'
                        this.arrTabComparisonTmp = this.arrTabComparisonAligner
                        break
                    case 'tmpoption_5':
                        this.tabName = 'aligner-overjet'
                        this.arrTabComparisonTmp = this.arrTabComparisonAligner
                        break
                    case 'tmpoption_6':
                        this.tabName = 'aligner-lower'
                        this.arrTabComparisonTmp = this.arrTabComparisonAligner
                        break
                    default:
                        this.tabName = 'aligner-all'
                        this.arrTabComparisonTmp = this.arrTabComparisonAligner
                        break
                }
                break
            case 'option_3':
                switch (id) {
                    case 'tmpoption_1':
                        this.tabName = 'xp-1'
                        this.arrTabComparisonTmp = this.arrTabComparisonXray
                        break
                    case 'tmpoption_2':
                        this.tabName = 'xp-2'
                        this.arrTabComparisonTmp = this.arrTabComparisonXray
                        break
                    case 'tmpoption_3':
                        this.tabName = 'xp-3'
                        this.arrTabComparisonTmp = this.arrTabComparisonXray
                        break
                    case 'tmpoption_4':
                        this.tabName = 'xp-4'
                        this.arrTabComparisonTmp = this.arrTabComparisonXray
                        break
                    case 'tmpoption_5':
                        this.tabName = 'xp-5'
                        this.arrTabComparisonTmp = this.arrTabComparisonXray
                        break
                    case 'tmpoption_6':
                        this.tabName = 'xp-6'
                        this.arrTabComparisonTmp = this.arrTabComparisonXray
                        break
                    default:
                        this.tabName = 'xp-all'
                        this.arrTabComparisonTmp = this.arrTabComparisonXray
                        break
                }
                break
            case 'option_4':
                switch (id) {
                    case 'tmpoption_1':
                        this.tabName = 'other-1'
                        this.arrTabComparisonTmp = this.arrTabComparisonOther
                        break
                    case 'tmpoption_2':
                        this.tabName = 'other-2'
                        this.arrTabComparisonTmp = this.arrTabComparisonOther
                        break
                    case 'tmpoption_3':
                        this.tabName = 'other-3'
                        this.arrTabComparisonTmp = this.arrTabComparisonOther
                        break
                    case 'tmpoption_4':
                        this.tabName = 'other-4'
                        this.arrTabComparisonTmp = this.arrTabComparisonOther
                        break
                    case 'tmpoption_5':
                        this.tabName = 'other-5'
                        this.arrTabComparisonTmp = this.arrTabComparisonOther
                        break
                    case 'tmpoption_6':
                        this.tabName = 'other-6'
                        this.arrTabComparisonTmp = this.arrTabComparisonOther
                        break
                    default:
                        this.tabName = 'other-all'
                        this.arrTabComparisonTmp = this.arrTabComparisonOther
                        break
                }
                break
            case 'option_5':
                switch (id) {
                    case 'tmpoption_1':
                        this.tabName = 'movie-1'
                        this.arrTabComparisonTmp = this.arrTabComparisonMovie
                        break
                    case 'tmpoption_2':
                        this.tabName = 'movie-2'
                        this.arrTabComparisonTmp = this.arrTabComparisonMovie
                        break
                    case 'tmpoption_3':
                        this.tabName = 'movie-3'
                        this.arrTabComparisonTmp = this.arrTabComparisonMovie
                        break
                    case 'tmpoption_4':
                        this.tabName = 'movie-4'
                        this.arrTabComparisonTmp = this.arrTabComparisonMovie
                        break
                    case 'tmpoption_5':
                        this.tabName = 'movie-5'
                        this.arrTabComparisonTmp = this.arrTabComparisonMovie
                        break
                    case 'tmpoption_6':
                        this.tabName = 'movie-6'
                        this.arrTabComparisonTmp = this.arrTabComparisonMovie
                        break
                    default:
                        this.tabName = 'movie-all'
                        this.arrTabComparisonTmp = this.arrTabComparisonMovie
                        break
                }
                break
            default:
                switch (id) {
                    case 'tmpoption_1':
                        this.tabName = 'tooth-right'
                        this.arrTabComparisonTmp = this.arrTabComparisonTooth
                        break
                    case 'tmpoption_2':
                        this.tabName = 'tooth-front'
                        this.arrTabComparisonTmp = this.arrTabComparisonTooth
                        break
                    case 'tmpoption_3':
                        this.tabName = 'tooth-left'
                        this.arrTabComparisonTmp = this.arrTabComparisonTooth
                        break
                    case 'tmpoption_4':
                        this.tabName = 'tooth-upper'
                        this.arrTabComparisonTmp = this.arrTabComparisonTooth
                        break
                    case 'tmpoption_5':
                        this.tabName = 'tooth-overjet'
                        this.arrTabComparisonTmp = this.arrTabComparisonTooth
                        break
                    case 'tmpoption_6':
                        this.tabName = 'tooth-lower'
                        this.arrTabComparisonTmp = this.arrTabComparisonTooth
                        break
                    default:
                        this.tabName = 'tooth-all'
                        this.arrTabComparisonTmp = this.arrTabComparisonTooth
                        break
                }
                break
        }

        this.emitTabName['tabName'] = this.tabName
        this.clientTopServices.emitChangeTabName(this.emitTabName)
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/comparison/modal-client-detail-comparison.component.ts